import styled from "styled-components"

import { when, eq, maxWidth, minWidth } from "utils"

import CroppedImage from "components/cropped-image"

export const Wrapper = styled.div`
  width: calc(100% - 5.4rem);
  margin: 0 2.7rem 3rem;
  border-bottom: 0.1rem solid #eee;

  ${minWidth.tablet`
    max-width: 58rem;
    margin: 0 auto 4rem;
  `}

  ${minWidth.hamburgerLarge`
    max-width: 72.5rem;
    margin: 0 auto 6rem;
  `}
`

export const Title = styled.h3`
  padding-bottom: 0.6rem;
  border-bottom: 0.5rem solid #eee;
  font-family: "Abril", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 2.4rem;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${({ theme }) => theme.colors.text.primary};
`

export const Products = styled.div`
  ${minWidth.tablet`
    ${eq("priority", 2)`
      display: flex;
      gap: 1.5rem;
    `}
  `}
`
export const ProductMetaData = styled.div`
  width: 50%;

  ${when("reverse")`
    margin-left: 2.5%;
    margin-right: 0;
  `}

  ${maxWidth.tablet`
    width: 100%;
    margin: 0;
  `}

  ${minWidth.tablet`
    ${eq("priority", 2)`
      width: 100%;
      margin: 0;
    `}
  `}
`
export const ProductWrapper = styled.div`
  margin: 3rem 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;

  &:not(:last-of-type) {
    padding-bottom: 2rem;
    border-bottom: 1px solid #eee;
  }

  ${maxWidth.tablet`
    margin: 1.2rem 0 2.4rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  `}

  ${minWidth.tablet`
    ${eq("priority", 2)`
      width: ${({ count }) => (count >= 3 ? "33.33%" : "50%")};
      margin: 2rem 0;
      ${({ count, idx }) => count === 2 && idx === 0 && "padding-right: 1.5rem;"}
      ${({ count, idx }) => count === 2 && idx === 1 && "padding-left: 1.5rem;"}
      ${({ count, idx }) => count > 2 && idx === 0 && "padding-right: 0.66rem;"}
      ${({ count, idx }) => count > 2 && idx === 1 && "padding: 0 0.33rem;"}
      ${({ count, idx }) => count > 2 && idx === 2 && "padding-left: 0.66rem;"}
      padding-bottom: 0 !important;
      border-bottom: 0 !important;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;

      ${ProductMetaData} {
        width: 75%;
        padding: 0.5rem 0;
        display: flex;
        flex-direction: column;
        flex: 1 0 auto;
        align-items: center;
        text-align: center;
      }
    `}
  `}
`
export const BuyLinkTitle = styled.a`
  ${maxWidth.tablet`
    ${eq("priority", 2)`
      cursor: default;
      pointer-events: none;
    `}
  `}
`
export const ProductTitle = styled.h2`
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 3.2rem;
  font-weight: 500;
  line-height: 1.19;
  letter-spacing: normal;
  color: ${({ theme }) => theme.colors.text.primary};

  ${eq("priority", 1)`
    font-size: 2.8rem;
  `}

  ${maxWidth.tablet`
    text-align: center;
  `}

  ${minWidth.tablet`
    ${eq("priority", 2)`
      margin-top: 1.6rem;
      font-size: 1.6rem;
      line-height: 1.35;
      text-decoration: underline;
      text-align: center;
      color: ${({ theme }) => theme.article.color};
      transition: filter 0.1s linear;

      &:hover {
        filter: brightness(0.8);
      }
    `}
  `}

  p {
    margin: 0;
  }
`
export const Brand = styled.p`
  margin: 1rem 0;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.8rem;
  font-weight: 500;
  line-height: 1.375;
  color: #222;

  ${eq("priority", 2)`
    text-align: center;
  `}
`

export const Placeholder = styled.div`
  ${eq("priority", 2)`
    flex: 1 0 auto;

    &:empty {
      margin: 0.75rem 0;
    }
  `}
`

export const ProductPrice = styled.div`
  margin: 1.8rem 0 1.4rem 0;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.4rem;
  font-weight: 500;
  color: #767676;

  ${maxWidth.tablet`
    margin: 1.5rem 0 2rem 0;
    text-align: center;
  `}

  ${minWidth.tablet`
    ${eq("priority", 2)`
      margin: 1rem 0 1.2rem 0;
      text-align: center;
    `}
  `}
`

export const ProductDescription = styled.div`
  margin-bottom: 2.3rem;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.8rem;
  line-height: 1.56;
  color: ${({ theme }) => theme.colors.text.primary};
`

export const ButtonLogoRow = styled.div`
  height: 4rem;
  display: flex;

  ${maxWidth.tablet`
    height: auto;
    flex-direction: column;
    align-items: center;
  `}

  ${minWidth.tablet`
    ${eq("priority", 2)`
      display: none;
    `}
  `}
`

export const BuyLink = styled.a`
  display: block;

  ${maxWidth.tablet`
    order: -1;
  `}
`

export const BuyButton = styled.button`
  height: 4rem;
  margin-right: 6rem;
  padding: 1rem;
  border-radius: 2.25rem;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.4rem;
  font-weight: 500;
  letter-spacing: 0.2rem;
  text-align: center;
  text-transform: uppercase;
  background-color: #b5471f;
  color: #fff;
  transition: filter 0.25s ease-in-out;

  &:hover {
    filter: brightness(0.8);
  }

  ${maxWidth.tablet`
    width: unset;
    margin-top: 1rem;
    margin-bottom: 1.6rem;
    margin-right: 0;
    padding: 1rem 3.7rem;
  `}
`
export const FloatingBuyLink = styled.a`
  display: none;

  ${minWidth.tablet`
    ${({ priority }) => priority !== 1 && "display: block;"}
  `}
`

export const FloatingBuyButton = styled(BuyButton)`
  position: absolute;
  width: 75%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  opacity: 0;
  transition: filter 0.25s ease-in-out, opacity 0.25s ease-in-out;
`

export const ProductLogo = styled(CroppedImage)`
  width: 9rem;
  height: 100%;

  ${maxWidth.tablet`
    height: 4rem;
  `}
`

export const ProductImage = styled(CroppedImage)`
  padding-top: ${({ priority }) => (priority === 1 ? "100%" : "75%")};
  opacity: 1;
  transition: opacity 0.25s ease-in-out;

  ${eq("priority", 1)`
    width: 100%;
  `}

  ${eq("priority", 2)`
    img {
      object-fit: contain;
    }
  `}
`

export const ImageWrapper = styled.div`
  position: relative;
  margin-left: 2.5%;

  ${eq("priority", 1)`
    width: 50%;
  `}

  ${eq("priority", 3)`
    width: 25%;
  `}


  ${when("reverse")`
    margin-left: 0;
    margin-right: 2.5%;
    order: -1;
  `}

  ${maxWidth.tablet`
    width: 100%;
    margin: 0;
    margin-bottom: 1.4rem;
    order: -1;
  `}

  &:hover ${FloatingBuyButton} {
    opacity: 1;
  }

  ${minWidth.tablet`
    ${eq("priority", 2)`
      width: 100%;
      margin: 0;
      order: -1;

      &:hover ${ProductImage} {
        opacity: 0.5;
      }
    `}
  `}
`
